import { useEffect } from 'react';
import { useModalStore } from '../store/portal/modalStore';
import { useStandardAlertStore } from '../store/portal/alertStore';
import { useLocation } from 'react-router-dom';
import { useMenu } from './useMenu';

/**
 * URL 변경 시 포탈 상태를 자동으로 정리하는 훅  
 */
export const usePortalAutoAction = () => {
  const { standardModal, clearModal } = useModalStore();
  const { queue, clearAll } = useStandardAlertStore();
  const { isMenuOpen, closeMenu } = useMenu();
  const location = useLocation();

  useEffect(() => {
    // URL이 바뀔 때마다 깔끔하게 정리 (idempotent 가정)
    if (standardModal) clearModal();
    if (queue.length > 0) clearAll();
    if (isMenuOpen) closeMenu();
  }, [location.pathname, location.search, location.hash]);

  return {
    hasActivePortal: !!(standardModal || queue.length > 0)
  };
}; 